export enum Status {
  ACTIVE = 'active',
  PASSIVE = 'passive',
}
